import { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './Modal.module.scss';

type TitleProps = {
  children: React.ReactNode;
  classNameModifier?: string;
};

const Title: FC<TitleProps> = ({ children, classNameModifier }) => (
  <h3 className={getClassNames(styles, 'title', classNameModifier)}>
    {children}
  </h3>
);

export default Title;
